import { createSlice } from "@reduxjs/toolkit";
import { setThemeMode } from "../../utils/session";

interface ThemeState {
  mode: "light" | "dark";
}

const initialState: ThemeState = {
  mode: (sessionStorage.getItem("themeMode") as "light" | "dark") || "light"
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
      setThemeMode(state.mode);
    },
    setTheme: (state, action) => {
      state.mode = action.payload;
      setThemeMode(state.mode)
    }
  }
});
// 
export const { toggleTheme, setTheme } = themeSlice.actions;
export default themeSlice.reducer;
